import { List, Record } from "immutable";

import {
  PREMISES,
  PremisesEquipments,
  B2BTasks,
  FREQUENCY,
  Agent,
  AGENT_PREFERENCE,
  NonStandardFrequencyShifts,
  KEY_PICK_B2B,
  B2BPricing,
  PremisesServices,
} from "@typings/b2b";
import { BookingAvailability, PricePlan } from "@typings/booking";
import { LocationsCollection } from "@typings/locations";
import { PROMO_CODE_NOTIFICATION, PAYMENT_METHODS } from "@typings/globals";
import { LOADING_STATE } from "@typings/reduxThunkActions";

export const LOCAL_STORAGE_KEY = "store:b2b";

export interface B2BReducer {
  calendar: Record<BookingAvailability>;
  premises: PREMISES;
  premisesServices: PremisesServices | null;
  premisesServicesFetched: boolean;
  surfaceArea: number | string;
  premisesEquipments: Record<PremisesEquipments>;
  recommendedDurationsApplied: boolean;
  recommendedDuration: number;
  tasks: Record<B2BTasks>;
  hasCleaningMaterials: boolean;
  execution: {
    date: string | null;
    time: string | null;
  };
  isExecutionDateTimeValidated: boolean; // to remove?
  availabilityLoadingState: LOADING_STATE;
  pricing: Record<B2BPricing>;
  nonStandardFrequencyShifts: NonStandardFrequencyShifts[];
  preselectedAgentUuid: string | null;
  agentPreference: AGENT_PREFERENCE;
  serviceLocationId: number;
  previousAgents: List<Record<Agent>>;
  isChoosingAnyBatmaid: boolean;
  form: Record<RegistrationForm>;
  locationUuid: string;
  contactAfterBooking: boolean;
  reservationUuid: string;
  hasPets: boolean;
  specialInstructions: string | null;
  keyPick: KEY_PICK_B2B;
  locationComment: string;
  availablePaymentMethods: List<PAYMENT_METHODS>;
  selectedPaymentMethod: PAYMENT_METHODS | null;
  pricingLoadingState: LOADING_STATE;
  locations: LocationsCollection;
  locationsLoadingState: LOADING_STATE;
  voucherToken: string;
  voucherMessage: string;
  voucherStatus: PROMO_CODE_NOTIFICATION;
  iDontKnowFrequencyNotification: boolean;
  iDontKnowDurationNotification: boolean;
  queryParams: string;
  additionalInfo?: string;
  pricePlanUuid: string | null;
  frequencies: List<FREQUENCY>;
  frequency: FREQUENCY;
  frequenciesLoadingState: LOADING_STATE;
  pricePlans: List<Record<PricePlan>>;
  pricePlansLoadingState: LOADING_STATE;
}

export interface RegistrationForm {
  // company
  name: string;
  phone: string;
  vat: string;
  sdi: string;
  email: string;
  address: string;
  serviceLocationId: number;
  floorAndDoor: string;
  entryCode: string;

  contactPersonFirstName: string;
  contactPersonLastName: string;
  contactPersonPhone: string;
  contactPersonEmail: string;
  loginEmail: string;
  password: string;
  marketingConsent: boolean;
}

export interface TelemetryCalendarContext {
  duration: number;
  frequency: FREQUENCY;
  displayedSlots: string[];
}
